import bbbbBusdCakeLp from "../abis/development/bbbbBusd/cakeLp";

const host = "https://bscscan.com/address";

export default [
  {
    name: "BBBB-BUSD",
    type: "busd",
    contractAddress: "0x6F3505364Da2f11Fc28f8e80494C34292F5bb90C",
    minApr: 159,
    abi: bbbbBusdCakeLp.abi,
    url: `${host}/0x6F3505364Da2f11Fc28f8e80494C34292F5bb90C`,
    decimals: 18,
  },
];
